import React from "react";

import { cn } from "@/lib/helpers/cn";

// chevron notch/tip cut, in px - kept as a literal in each clip-path string below
// since Tailwind's class scanner requires static arbitrary values
const CHEVRON_WITH_NOTCH =
  "tw:[clip-path:polygon(0_0,calc(100%-10px)_0,100%_50%,calc(100%-10px)_100%,0_100%,10px_50%)]";
const CHEVRON_FLAT_LEFT =
  "tw:[clip-path:polygon(0_0,calc(100%-10px)_0,100%_50%,calc(100%-10px)_100%,0_100%)]";

export function GuidedCallProgress(props) {
  const { currentStep, workflow } = props;

  return (
    <div className="tw:flex tw:flex-row tw:items-center tw:justify-center">
      {workflow.steps.map((workflowStep, index) => {
        const isFirst = index === 0;
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <div
            className={cn(
              "tw:relative tw:flex tw:h-8 tw:w-auto tw:min-w-32 tw:items-center tw:justify-center tw:border-l tw:border-stroke-navy-primary tw:px-5 tw:text-xs tw:font-bold tw:whitespace-nowrap tw:text-(--color-fill-navy-primary)",
              isFirst ? CHEVRON_FLAT_LEFT : CHEVRON_WITH_NOTCH,
              isActive || isCompleted ? "tw:bg-fill-teal-secondary" : "tw:bg-fill-white",
            )}
            key={index}
          >
            <b>
              {index + 1}. {workflowStep.short}
            </b>
          </div>
        );
      })}
    </div>
  );
}
